import { render, staticRenderFns } from "./ProductDetailsMED.vue?vue&type=template&id=3c6f4220&scoped=true"
import script from "./ProductDetailsMED.vue?vue&type=script&lang=js"
export * from "./ProductDetailsMED.vue?vue&type=script&lang=js"
import style0 from "./ProductDetailsMED.vue?vue&type=style&index=0&id=3c6f4220&prod&scoped=true&lang=scss"
import style1 from "./ProductDetailsMED.vue?vue&type=style&index=1&id=3c6f4220&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c6f4220",
  null
  
)

export default component.exports